export default __webpack_public_path__ + "static/media/boost-white.282567bb.svg";